import { SendEventOnLoad } from "~/components/Analytics";
import ProductCard, {
  Layout as cardLayout,
} from "~/components/product/ProductCard";
import Icon from "~/components/ui/Icon";
import Header from "~/components/ui/SectionHeader";
import Slider from "~/components/ui/Slider";
import SliderJS from "~/components/ui/SliderJS";
import { useId } from "react";
import { useOffer } from "~/sdk/useOffer";

import type { Product } from "@decocms/apps-commerce/types";
import { mapProductToAnalyticsItem } from "@decocms/apps-commerce/utils/productToAnalyticsItem";

export interface Props {
  products: Product[] | null;
  title?: string;
  description?: string;
  layout?: {
    headerAlignment?: "center" | "left";
    headerfontSize?: "Normal" | "Large";
  };
  cardLayout?: cardLayout;
}

function ProductShelf({
  products,
  title,
  description,
  layout,
  cardLayout,
}: Props) {
  const id = useId();
if (!products || products.length === 0) {
    return null;
  }

  return (
    <div className="w-full container py-8 flex flex-col gap-12 lg:gap-16 lg:py-10">
      <Header
        title={title || ""}
        description={description || ""}
        fontSize={layout?.headerfontSize || "Large"}
        alignment={layout?.headerAlignment || "center"}
      />

      <div
        id={id}
        className="container grid grid-cols-[48px_1fr_48px] px-0 sm:px-5"
      >
        <Slider className="carousel carousel-center sm:carousel-end gap-6 col-span-full row-start-2 row-end-5">
          {products?.map((product, index) => (
            <Slider.Item
              index={index}
              className="carousel-item w-[270px] sm:w-73 first:pl-6 sm:first:pl-0 last:pr-6 sm:last:pr-0"
            >
              <ProductCard
                product={product}
                itemListName={title}
                layout={cardLayout}
                preload={index === 0}
              />
            </Slider.Item>
          ))}
        </Slider>

        <>
          <div className="hidden relative sm:block z-10 col-start-1 row-start-3">
            <Slider.PrevButton className="btn btn-circle btn-outline absolute right-1/2 bg-base-100">
              <Icon size={24} id="ChevronLeft" strokeWidth={3} />
            </Slider.PrevButton>
          </div>
          <div className="hidden relative sm:block z-10 col-start-3 row-start-3">
            <Slider.NextButton className="btn btn-circle btn-outline absolute left-1/2 bg-base-100">
              <Icon size={24} id="ChevronRight" strokeWidth={3} />
            </Slider.NextButton>
          </div>
        </>
        <SliderJS rootId={id} />
        <SendEventOnLoad
          event={{
            name: "view_item_list",
            params: {
              item_list_name: title,
              items: products.map((product) =>
                mapProductToAnalyticsItem({
                  product,
                  ...(useOffer(product.offers)),
                })
              ),
            },
          }}
        />
      </div>
    </div>
  );
}

export default ProductShelf;
